import React from 'react';
import { Link } from 'react-router-dom';

const PageLink: React.FC<{className?: string, to?: string, bold?: boolean, onClick?: React.MouseEventHandler<HTMLAnchorElement>}> = ({children, onClick, bold, className = '', to = ''}) => {
  return (
    <Link to={to} onClick={onClick} className={(bold ? 'bold ' : '') + 'text-primaryColor ' + className}>{children}</Link>
  )
}
export default PageLink;
